import { z } from "zod";
// The availability probe's response. This endpoint is publicly reachable from
// every Front Door probe region, so it reports whether the system can serve
// requests and nothing about why it cannot.
//
// `version` is the commit SHA the server was built from ("dev" when no deploy
// wrote one), so a deploy can confirm the new build is the one answering. It
// discloses nothing new: the same SHA is already in the public client bundle.
export const HealthResponseSchema = z.object({
    ok: z.boolean(),
    version: z.string(),
});
